import { MeshTransmissionMaterial } from "@react-three/drei"
import { moveAxisRange, rotateAxisRange, moveAxis } from '../../../utils/moveObjects'
import { useFrame } from "@react-three/fiber"
import { useEffect, useRef } from "react"
import { useActsStore } from "../../../store/useActsStore"


export default function Cockpit() {
    const cockpit = useRef()
    const initialPos = [0.4, -0, 0]

    useFrame((_, delta) => {
        const stateActe = useActsStore.getState()
        const id = stateActe.getCurrentActId()

        const holdProgress = stateActe.actsProgress[id]?.holdProgress ?? 0

        if(id ===0) {
            if (!cockpit.current) return
            moveAxisRange(
                cockpit,
                'x',
                initialPos[0],
                -0.53,
                holdProgress,
                0.2,
                0.93,
                5,
                delta
            )
            moveAxisRange(
                cockpit,
                'y',
                initialPos[1],
                -0.53,
                holdProgress,
                0.92,
                1,
                5,
                delta
            )
            rotateAxisRange(
                cockpit,
                'y',               
                0,                 
                Math.PI * 100,     
                holdProgress,
                0.2,
                0.5,
                0.1,
                1,
                delta
            )
        }    


    })

    return <>
        <mesh
            position={initialPos}
            castShadow
            ref={cockpit}
        >
            <sphereGeometry args={[0.03, 32, 32]} />
            <meshPhysicalMaterial
                roughness={0}
                metalness={0}
                thickness={0.2}
                transmission={0.9}
                attenuationColor="#dbd5ff"
                attenuationDistance={0.45}
                ior={1.5}
                clearcoat={1.5}
                clearcoatRoughness={0.05}
                dispersion={1}
            // dithering 
            />
        </mesh>
    </>
}